import { Avatar, CheckCircleIcon, Image } from 'native-base'
import { useRecoilValue } from 'recoil'
import { userState } from '../state/atoms'

const UserPhoto = (props) => {
    // Global State
    const userData = useRecoilValue(userState)
    const initials = userData?.first_name.split('')[0] + userData?.last_name.split('')[0]
    return (
        <Avatar
            style={{ margin: 20 }}
            bg="#6c387a"
            size={props.size}
            source={{
                uri: props.image || userData?.image,
            }}
        >
            {initials || (
                <Image
                    style={{
                        marginLeft: 5,
                        width: '85%',
                        height: undefined,
                        aspectRatio: 205 / 152,
                    }}
                    source={require('../assets/logos/ZHOnly-white.png')}
                />
            )}
            {userData?.account?.isVerified && (
                <Avatar.Badge bg="#fff">
                    <CheckCircleIcon color="#228C22" size={5} />
                </Avatar.Badge>
            )}
        </Avatar>
    )
}

export default UserPhoto
